// import logo from './logo.svg';
import './App.css';
import Calc from './calculator';

function App() {
  return (
    <div>
      <Calc/>
    </div>
  );
}

export default App;
